<template>
    <div>
        <div class="">
            <div class="alert alert-info alert-dismissable">
                <a class="panel-close close" data-dismiss="alert">×</a> 
                Kindly verify your phone number. <strong><button @click.prevent="sendOTP()" class="btn btn-link btn-sm"> Click to begin</button></strong>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="verifyPhoneModal" ref="verifyPhoneModal" tabindex="-1" role="dialog" aria-labelledby="verifyPhoneModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" id="newContactModalLabel">Phone Verification</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="confirmOTP()">
                            <div class="form-group mb-4 px-lg-2">
                                <label for="name" class="mb-1">
                                    <small>OTP</small>
                                </label>
                                <input type="text" v-model="form.Otp" class="form-control">
                            </div>
                            <p v-show="otp_sent" class="text-success h6 text-center font-weight-bold mb-3">
                                {{ otp_message }}
                            </p>

                            <div class="form-group mb-4 px-lg-2">
                                <button class="btn btn-custom btn-lg btn-block">Submit</button>
                            </div>
                            <div class="d-flex flex-column justify-content-center align-items-center mb-3">
                                <h5 class="text-muted small">Didn't receive an OTP?</h5>

                                <button @click.prevent="resendOTP()" class="btn btn-link">Resend OTP</button>
                            </div>
                            
                        </form>
                        
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            otp_sent: true,
            otp_message: '',
            form: {
                Otp: ''
            }
        }
    },

    methods: {
        async sendOTP() {
            try {
                const OTP = await axios.post('/auth/me/verification/phone/verify');
                
                if (OTP.status == 200) {

                    this.$notify({
                        group: 'foo',
                        type: 'Success',
                        title: 'Success',
                        text: 'An OTP has been sent to your phone for verification'
                    });

                    $(this.$refs.verifyPhoneModal).modal('show');
                }    
            } catch (error) {
                // console.log(error.response);
            }
        },
        async resendOTP() {
            try {
                const OTP = await axios.post('/auth/me/verification/phone/resend');

                this.otp_sent = true;
                this.otp_message = 'You have been sent another OTP'

                this.$notify({
                    group: 'foo',
                    type: 'Success',
                    title: 'Success',
                    text: 'You have been sent another OTP'
                });


            } catch (error) {
                // console.log(error.response)
            }
        },

        async confirmOTP() {

            const data = {
                type: 'phone',
                code: this.form.Otp
            };
            try {
                const OTP = await axios.post('/auth/me/verification/phone/confirm', data);

                if (OTP.status == 200) {

                    $(this.$refs.verifyPhoneModal).modal('hide');

                    this.$notify({
                        group: 'foo',
                        type: 'Success',
                        title: 'Success',
                        text: 'You have successfully verified your phone number'
                    });
                }
            } catch (error) {
                // console.log(error.response)
            }
        }
    }
}
</script>

<style>

</style>